import type { ShirtSize, RsvpInput } from '../../../lib/types';
import type { DraftChild, ParentContact } from './types';

export const SHIRT_SHORT: Record<ShirtSize, string> = {
  YXS: 'XS',
  YS: 'S',
  YM: 'M',
  YL: 'L',
  YXL: 'XL',
};

const generateDraftId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `draft-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const emptyChild = (): DraftChild => ({
  draftId: generateDraftId(),
  child_name: '',
  status: 'coming',
  shirt_size: null,
  character_id: null,
  submitted: false,
  error: null,
});

export const toRsvpInput = (c: DraftChild, p: ParentContact): RsvpInput => ({
  child_name: c.child_name.trim(),
  parent_name: p.parent_name.trim(),
  parent_email: p.parent_email.trim(),
  parent_phone: p.parent_phone.trim() || null,
  rsvp_status: c.status,
  character_id: c.status === 'coming' ? c.character_id : null,
  shirt_size: c.shirt_size,
});
